// ═══════════════════════════════════════════════════════════════
// CostIndicator — Indicateur coût discret pour messages chat
// Affiché dans le footer de chaque message AI
// ═══════════════════════════════════════════════════════════════

import React from 'react';

const formatCost = (usd) => {
    if (!usd || usd === 0) return '$0';
    if (usd < 0.001) return `$${usd.toFixed(6)}`;
    if (usd < 0.01) return `$${usd.toFixed(4)}`;
    if (usd < 1) return `$${usd.toFixed(3)}`;
    return `$${usd.toFixed(2)}`;
};

const formatTokens = (n) => {
    if (!n) return '0';
    if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
    return `${n}`;
};

const CostIndicator = ({ cost, sessionCost = 0 }) => {
    if (!cost) return null;

    const { cost_usd, input_tokens, output_tokens, is_estimated } = cost;
    const totalTokens = (input_tokens || 0) + (output_tokens || 0);

    const tooltipLines = [
        `Input: ${formatTokens(input_tokens)} tok`,
        `Output: ${formatTokens(output_tokens)} tok`,
        is_estimated ? '(estimé par caractères)' : '(tokens réels)',
        '',
        `Session: ~${formatCost(sessionCost)}`,
        `x2: ~${formatCost(sessionCost * 2)}`,
    ];

    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
                fontSize: '10px',
                color: 'var(--text-secondary)',
                padding: '2px 8px',
                borderRadius: '4px',
                background: 'rgba(29, 78, 216, 0.06)',
                border: '1px solid rgba(29, 78, 216, 0.15)',
                cursor: 'default',
                marginLeft: '6px',
                fontFamily: 'monospace',
                letterSpacing: '-0.3px',
            }}
            title={tooltipLines.join('\n')}
        >
            ~{formatCost(cost_usd)} · {formatTokens(totalTokens)} tok
            {is_estimated && (
                <span style={{ opacity: 0.6, fontSize: '9px' }}>~</span>
            )}
        </span>
    );
};

export default CostIndicator;
